import { logout, getInstance } from '../services/auth.js';
import { t } from '../i18n.js';

export function createHeader() {
  const header = document.createElement('div');
  header.className = 'app-header';
  
  const title = document.createElement('h3');
  title.className = 'app-title';
  const instance = getInstance();
  title.textContent = instance
    ? `${instance.charAt(0).toUpperCase()}${instance.slice(1)}`
    : 'AssistGo';
  
  // Right section with Logout button
  const rightSection = document.createElement('div');
  rightSection.className = 'header-right-section';
  
  const logoutButton = document.createElement('button');
  logoutButton.className = 'logout-button';
  logoutButton.textContent = t('logout');
  logoutButton.onclick = async () => {
    await logout();
    window.location.reload();
  };
  
  rightSection.appendChild(logoutButton);
  
  header.appendChild(title);
  header.appendChild(rightSection);
  
  return header;
} 